/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faClipboardUser} from '@fortawesome/pro-duotone-svg-icons';

const SelfRegistrationIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faClipboardUser} {...props} />
);

export default SelfRegistrationIcon;
